/**
 * Normalizes a review action value to a consistent format for comparison.
 * Converts to uppercase and replaces spaces with underscores.
 * @param value The review action value to normalize
 * @returns Normalized string (e.g., "No Follow Up" -> "NO_FOLLOW_UP")
 */
export function normalizeReviewActionValue(value: string): string {
  return value.trim().toUpperCase().replace(/\s+/g, '_');
}
